import React from 'react';
import ModeLogo from '@/Components/ModeLogo';
import { cn } from '@/utils';

export default function ModeInline({
  mode,
  className,
}: {
  mode: App.Data.ModeData;
  className?: string;
}) {
  return (
    <span className={cn('flex items-center gap-2 ', className)}>
      <ModeLogo slug={mode.slug} className="h-4 w-4" />
      {mode.name}
    </span>
  );
}
